<mat-form-field appearance="outline">
  <mat-label>{{ label() }}</mat-label>
  @if (autocompleteControl.value?.code) {
    <lib-asset-icon
      class="selected-asset-icon"
      matPrefix
      [code]="autocompleteControl.value?.code ?? null"
    ></lib-asset-icon>
  }
  <input
    matInput
    [readonly]="readOnly()"
    type="text"
    [formControl]="autocompleteControl"
    [matAutocomplete]="assetAutocomplete"
    #trigger="matAutocompleteTrigger"
  />
  @if (autocompleteControl.value && !autocompleteControl.disabled && !readOnly()) {
    <button (click)="clear($event)" class="clear-field" mat-icon-button matSuffix>
      <mat-icon>close</mat-icon>
    </button>
  }
  <mat-autocomplete
    [hideSingleSelectionIndicator]="true"
    [autoActiveFirstOption]="true"
    #assetAutocomplete="matAutocomplete"
    [displayWith]="displayOption"
    (opened)="onAutocompleteOpened(trigger)"
    (closed)="onAutocompleteClosed()"
  >
    @for (option of filteredOptions$ | async; track trackById($index, option)) {
      <mat-option [value]="option">
        <div class="option">
          <lib-asset-icon class="option__asset-icon" [code]="option.code ?? null"></lib-asset-icon>
          <span>{{ displayOption(option) }}</span>
        </div>
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
